import React from "react";
import { Grid } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import { setSelectedPatientPosition } from "state/slices/SceneSlice";
import { builder } from "Classes/global";
import { useTypedDispatch, useTypedSelector } from "hooks/store";
import { openDialog } from "state/slices/DialogSlice";

import lateral_left_side_female from "assets/images/preset/female/Lateral_Left_Female.png";
import lateral_right_side_female from "assets/images/preset/female/Lateral_Right_Female_.png";
import modified_lloyd_davies_female from "assets/images/preset/female/Modified_Lloyds_Davies_Female.png";
import plevic_set_up_female from "assets/images/preset/female/Pelvic_Set_Up_Female.png";
import sigmoid_set_up_female from "assets/images/preset/female/Sigmoid_Set_up_Female.png";
import splenic_flexure_set_up_female from "assets/images/preset/female/Splenic_Flexure_Set_Up_Female.png";
import split_leg_position_female from "assets/images/preset/female/Split_Leg_Position_Femal.png";
import upperGI_set_up_female from "assets/images/preset/female/UpperGI_set_up_Female_.png";
import upperGI_tilt_set_up_female from "assets/images/preset/female/UpperGI_tilt_set_up_Female_.png";

import lateral_left_side_male from "assets/images/preset/male/Lateral_Left_Male_.png";
import lateral_right_side_male from "assets/images/preset/male/Lateral_Right_Male_.png";
import modified_lloyd_davies_male from "assets/images/preset/male/Modified_Lloyds_Davies_Male.png";
import plevic_set_up_male from "assets/images/preset/male/Pelvic_Set_Up_Male.png";
import sigmoid_set_up_male from "assets/images/preset/male/Sigmoid_Set_up_Male_.png";
import splenic_flexure_set_up_male from "assets/images/preset/male/Splenic_Flexure_Set_Up_Male_.png";
import split_leg_position_male from "assets/images/preset/male/Split_Leg_Position_Male.png";
import upperGI_set_up_male from "assets/images/preset/male/UpperGI_set_up_Male_.png";
import upperGI_tilt_set_up_male from "assets/images/preset/male/UpperGI_tilt_set_up_Male.png";

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
const PatientPositionItem = ({ item }: any): JSX.Element => {
    const dispatch = useTypedDispatch();
    const type = useTypedSelector((store) => store.Dialog.type);

    const handleLoad = (): void => {
        dispatch(setSelectedPatientPosition(item.name));
        builder.room.updatePatientPosition(item.name);
        dispatch(openDialog({ isDialogOpen: false, type }));
    };

    const renderImage = (): string => {
        let image: string;
        switch (item.name) {
            case "Splenic Flexure Set Up Female":
            default:
                image = splenic_flexure_set_up_female;
                break;
            case "Splenic Flexure Set Up Male":
                image = splenic_flexure_set_up_male;
                break;
            case "Sigmoid Set up Female":
                image = sigmoid_set_up_female;
                break;
            case "Sigmoid Set up Male":
                image = sigmoid_set_up_male;
                break;
            case "UpperGI tilt set up Female":
                image = upperGI_tilt_set_up_female;
                break;
            case "UpperGI tilt set up Male":
                image = upperGI_tilt_set_up_male;
                break;
            case "Pelvic Set Up Female":
                image = plevic_set_up_female;
                break;
            case "Pelvic Set Up Male":
                image = plevic_set_up_male;
                break;
            case "Lateral Left Female":
                image = lateral_left_side_female;
                break;
            case "Lateral Left Male":
                image = lateral_left_side_male;
                break;
            case "Lateral Right Female":
                image = lateral_right_side_female;
                break;
            case "Lateral Right Male":
                image = lateral_right_side_male;
                break;
            case "UpperGI set up Female":
                image = upperGI_set_up_female;
                break;
            case "UpperGI set up Male":
                image = upperGI_set_up_male;
                break;
            case "Split Leg Position Female":
                image = split_leg_position_female;
                break;
            case "Split Leg Position Male":
                image = split_leg_position_male;
                break;
            case "Modified Lloyds Davies Female":
                image = modified_lloyd_davies_female;
                break;
            case "Modified Lloyds Davies Male":
                image = modified_lloyd_davies_male;
                break;
            case "Lateral Left Armless Male":
                image = modified_lloyd_davies_male;
                break;
            case "Lateral Right Armless Male":
                image = modified_lloyd_davies_male;
                break;
            case "Lateral Left Armless Female":
                image = modified_lloyd_davies_female;
                break;
            case "Lateral Right Armless Female":
                image = modified_lloyd_davies_female;
                break;
        }
        return image;
    };

    return (
        <Grid item sm={12}>
            <Card className="patientCard" onClick={handleLoad} style={{ cursor: "pointer" }}>
                <CardMedia component="img" height="300" image={renderImage()} alt="patient item" />
                <CardContent className="cardContent">
                    <Grid container justifyContent="space-between" alignItems="center">
                        <Grid item xs={12}>
                            <Button startIcon={<ArrowForwardIosIcon className="iconArrow" />}>
                                Load
                            </Button>
                        </Grid>
                    </Grid>
                    {item.name}
                </CardContent>
            </Card>
        </Grid>
    );
};

export default PatientPositionItem;
